import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const DUMMY = {
  total_entered_kg:      "42,300 kg",
  total_sorted_kg:       "38,100 kg",
  total_boxes_packed:    "1,240",
  total_paste_boxes:     "320",
  kg_rejected:           "1,800 kg",
};

const boxes = [
  { key: "total_entered_kg",   label: "Total Entered KG",         theme: "orange" },
  { key: "total_sorted_kg",    label: "Total Sorted (KG)",         theme: "orange" },
  { key: "total_boxes_packed", label: "Total Boxes Packed",        theme: "green"  },
  { key: "total_paste_boxes",  label: "Total Paste Boxes Packed",  theme: "green"  },
  { key: "kg_rejected",        label: "KG Rejected",               theme: "red"    },
];

const BrokerageOverview = ({ data = DUMMY, isLoading = false }) => (
  <DashboardCard title="Brokerage Overview">
    <div className="fqm-grid">
      {boxes.map((b) => (
        <div key={b.key} className={`pp-brokering-box bro-box-${b.theme}`}>
          <div className="pp-brokering-box-label">{b.label}</div>
          <div className="pp-brokering-box-value">
            {isLoading
              ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
              : (data?.[b.key] ?? "0")
            }
          </div>
        </div>
      ))}
    </div>
  </DashboardCard>
);

export default BrokerageOverview;
